<!--
    培训统计
-->
<template>
    <div class="page">
        <el-form class="page-query" :inline="true" size="mini">
            <el-form-item :label="$t('train.name')">
                <el-input v-model="formSearch.name" :placeholder="$t('tip.name')"
                          @keyup.enter.native="query" clearable></el-input>
            </el-form-item>
            <!--培训相关类型-->
            <select-multiple :nameArrays="selectNames"
                             @getTrainTypeVal="getTrainTypeVal"
                             @getTrainModeVal="getTrainModeVal"
                             @getExamFormVal="getExamFormVal">
            </select-multiple>
            <!--组织机构-->
            <select-multi-orgs @orgsChange="orgsChange"></select-multi-orgs>

            <el-form-item :label="$t('train.time')">
                <statistic-time-picker @getTimePicker="getTimePicker"></statistic-time-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="query" round>{{$t('c.query')}}</el-button>
            </el-form-item>
        </el-form>

        <div class="page-table">

            <div class="page-operate" >
                <!-- 2020/8/3 深圳租户特有 -->
                <template v-if="userInfo.enterpriseCode == '31'">
                    <el-tooltip class="item" effect="dark" content="下载培训数据统计表" placement="top-start" :hide-after="1000">
                        <a href="https://s3.cn-north-1.amazonaws.com.cn/s3.anjianba.cn/download/zh/民航安全检查员（货邮安检部）线上培训数据统计表-原始数据.xlsx"
                           class="el-button el-button--mini" download="培训数据统计表">
                            <i class="nucfont inuc-word"></i>
                        </a>
                    </el-tooltip>
                </template>

                <el-tooltip class="item" effect="dark" content="批量导出培训统计" placement="top-start" :hide-after="1000">
                    <el-button size="small" @click="exportTrainStats" :disabled="!selectIds.length"><i class="nucfont inuc-daochu"></i></el-button>
                </el-tooltip>
            </div>

            <data-tables class="form-table"
                         ref="trainTable"
                         :data="tableData"
                         :table-props="tableProps"
                         :current-page.sync="currentPage"
                         :page-size="20"
                         :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                         @selection-change="handleSelectionChange"
            >
                <!-- column checkbox -->
                <el-table-column type="selection" width="55px" :reserve-selection="true" align="center"></el-table-column>

<!--                <el-table-column type="index" width="40" align="center"></el-table-column>-->
                <el-table-column property="name" :label="$t('train.name')" align="center" min-width="180px" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.kind" style="float: left;">
                            <i class="nucfont inuc-dingwei" style="color: #999;"></i>
                        </span>
                        {{scope.row.name}}
                    </template>
                </el-table-column>
                <el-table-column v-for="(title, index) in titles" :prop="title.prop" :label="title.label"
                                 :key="index"
                                 align="center"
                                 :width="title.width"
                                 :min-width="title.minWidth"
                                 show-overflow-tooltip
                                 :sortable="title.sortable">
                </el-table-column>
                <el-table-column property="percent" :label="$t('train.percent')" align="center" width="110px" sortable>
                    <span class="progress" slot-scope="scope">
                        {{Math.round(scope.row.percent * 10000) / 100 + "%"}}
                    </span>
                </el-table-column>
                <el-table-column :label="$t('c.creator')" align="center" sortable property="creatorName">
                    <span slot-scope="scope">
                       {{scope.row.creatorName}}
                    </span>
                </el-table-column>
                <el-table-column :label="$t('c.operation')" align="center" width="140">
                    <div class="btn-cell" slot-scope="scope">
                        <i class="nucfont inuc-preview"
                           :title="$t('c.view')"
                           @click="previewPlan(scope.row)"></i>
                        <i class="nucfont inuc-feedback operate-feedbac"
                           v-if="scope.row.needSurvey"
                           :title="$t('count.feedback')"
                           @click="$router.push({name: 'surveyPaper', params: {id: scope.row.id}})"></i>
                    </div>
                </el-table-column>
            </data-tables>
        </div>
        <transition enter-active-class="animated zoomInRight"
                    leave-active-class="animated zoomOutUp">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
    import api from '@/api';
    import {Ticket} from '@/utils';
    import SelectMultiOrgs from '@components/SelectMultiOrgs';
    import SelectMultiple from '@components/Selectmultiple';
    import StatisticTimePicker from '@components/Statistics/StatisticTimePicker';
    import {mapGetters} from 'vuex';
    import qs from 'qs'
    import axios from 'axios'

    export default {
        data() {
            return {
                formSearch: {
                    name: undefined,
                    orgIds: [],
                    forms: [],
                    types: [],
                    kinds: [],
                },
                selectNames: [
                    {
                        key: "trainType",
                    }, {
                        key: "trainMode",
                    }, {
                        key: "examForm",
                    }],
                tableData: [],
                tableProps: {
                    border: true,
                    stripe: true,
                    rowKey: row => row.id,
                    height: "auto"
                },
                currentPage: 1,
                titles: [
                    {
                        prop: 'typeName',
                        label: this.$t('train.type')
                    }, {
                        prop: 'formName',
                        label: this.$t('c.examType')
                    }, {
                        prop: 'datetime',
                        label: this.$t('c.date'),
                        width: '160px',
                        sortable: 'custom'
                    }, {
                        prop: 'participants',
                        label: this.$t('train.memberNum'),
                        width: '110px',
                        sortable: 'custom'
                    },
//                    {
//                        prop: 'trainProgress',
//                        label: this.$t('train.percent'),
//                        width: '110px'
//                    }
                ],
                userInfo: Ticket.get(),

                selectIds: []
            }
        },
        created() {
            this.query();
        },
        mounted() {
        },
        computed: {
            ...mapGetters([
                'orgTree',
            ])
        },
        methods: {
            query() {
                this.currentPage = 1;
                let queryData = {...this.formSearch};

                ['types', 'forms'].forEach(v => {
                    if (this.formSearch[v].includes(0)) {
                        delete queryData[v];
                    }
                });

                if (queryData.kinds.indexOf(0) > -1) {
                    delete queryData.kinds
                } else if (queryData.kinds.length && queryData.kinds.indexOf(0) < 0) {
                    queryData.kinds = queryData.kinds.map(v => v-1)
                }

                api.trainingRecord(queryData).then(res => {
                    if (res.package) {
                        this.tableData = res.package;
//                        if(this.tableData.length && this.tableData.length>0) {
//                            this.tableData.forEach(ele => {
//                                ele['trainProgress'] = Math.round(ele.percent * 10000) / 100 + '%'
//                            })
//                        }
                    }
                })
            },

            handleSelectionChange(arr) {
                this.selectIds = arr.map(v => v.id)
            },

            exportTrainStats() {
                const token = Ticket.get().access_token;
                const culture = this.$i18n.locale;

                let url = `${APIURI}/api/Export/Excel/TrainingOnlineBatchStatistics?culture=${culture}&ui-culture=${culture}`
                let queryData = qs.stringify({
                    planIds: this.selectIds,
                })

                const service = axios.create()
                service({
                    method: 'post',
                    url,
                    data: queryData,
                    responseType: 'blob',
                    headers: {
                        'content-disposition': `attachment`,
                        'Authorization': `Bearer ${token}`
                    },
                })
                    .then(res => {
                        const blob = res.data
                        const url = window.URL.createObjectURL(blob)
                        const link = document.createElement('a')
                        link.style.display = 'none'
                        link.href = url
                        link.setAttribute('download', '培训统计表')
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)

                        this.$refs.trainTable.$refs.elTable.clearSelection();
                    })
            },

            orgsChange(data) {
                this.formSearch.orgIds = data;
            },
            getTrainTypeVal(data) {
                this.formSearch.types = data;
            },
            getTrainModeVal(data) {
                this.formSearch.kinds = data;
            },
            getExamFormVal(data) {
                this.formSearch.forms = data;
            },
            getTimePicker(time) {
                this.formSearch = Object.assign(this.formSearch, {...time})
            },
            previewPlan({id,kind}){
                if(kind){
                    this.$router.push({name: 'trainOfflineDetail',params: {planId: id}})
                }else{
                    this.$router.push({name: 'trainDetail',params: {planId: id}})
                }
            }
        },
        watch: {},
        components: {
            SelectMultiOrgs,
            SelectMultiple,
            StatisticTimePicker
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../style/const';
    .progress {
        display: inline-block;
        width: 60px;
        background-color: #2FC0A1;
        color: #fff;
        text-align: center;
        border-radius: 10px;
    }
</style>
